import React from 'react';
import {Text} from '@unthinkable/react-core-components';

export const LineSeparator = ({color = '#F0F0F0'}) => {
  return <Text style={{color}}>|</Text>;
};
